import {Map} from 'immutable'

const getOnlineCoworkers = (state) => {
    return state.getIn(['employee', 'items'], Map()).filter((employee) => {
        return (
            employee.get('is_online') && state.getIn(['user','login','id']) !== employee.get('id')
        )
    })
}
const getOfflineCoworkers = (state) => {
    return state.getIn(['employee', 'items']).filter((employee) => {
        return (
            !employee.get('is_online') && state.getIn(['user', 'login', 'id']) !== employee.get('id')
        )
    })
}

const getCoworkers = (state) => state.getIn(['employee', 'items'], Map()).filter((employee) => state.getIn(['user', 'login', 'id']) !== employee.get('id') && employee.size > 0) //Check if mapsize > 0
const getAll = (state) => state.getIn(['employee', 'items'])


const getById = (state, employeeId) => state.getIn(['employee', 'items', employeeId], Map())

const getImageUrl = (employee) => {
    let url = '/images/employee-avatar.png'
    if(!employee) return url
    url = employee.get('image_url')
    if(!url) return '/images/employee-avatar.png'
    return url
}

const getProfilePicture = (employee) => {
    if(!employee){
        return null;
    }else{
        const imageUrl = employee.get('image_url');
        if(imageUrl){
            return imageUrl
        }else{
            return '/images/employee-avatar.png';
        }
    }
}
const getImage = getImageUrl

const getEmployeeName = (employee) => employee.get('name')
const getName = getEmployeeName

const getDisplayName = (employee) => employee.get('display_name');

const getEmployeeEmail = (employee) => employee.get('email')
const email = getEmployeeEmail

const getEmployeeRole = (employee) => employee.get('role')
const role = getEmployeeRole

export default {
    getById,
    getCoworkers, getOnlineCoworkers, getOfflineCoworkers, getAll,
    getImageUrl,getImage,
    getEmployeeName, getName,
    getEmployeeRole, role,
    getEmployeeEmail, email,
    getProfilePicture,
    getDisplayName
}



// WEBPACK FOOTER //
// ./src/model/Employee/selector.js